export default "__VITE_ASSET__6QWDqazQ__"